/* Horizon Interiores — relógio do selo Relâmpago (snippets/hz-selos.liquid).
   data-hz-fim = fim em segundos (epoch). Ao zerar, o selo sai sem recarregar a página. */
(function () {
  if (window.hzSelosRelogio) return;
  window.hzSelosRelogio = true;
  var z = function (n) { return (n < 10 ? '0' : '') + n; };
  function tick() {
    var agora = Date.now() / 1000;
    document.querySelectorAll('.hz-selo--relampago[data-hz-fim]').forEach(function (el) {
      var s = Math.floor(+el.getAttribute('data-hz-fim') - agora);
      if (s <= 0) { el.remove(); return; }
      var t = el.querySelector('.hz-selo__tempo');
      if (t) t.textContent = z(Math.floor(s / 3600)) + ':' + z(Math.floor(s / 60) % 60) + ':' + z(s % 60);
    });
  }
  tick();
  setInterval(tick, 1000);
})();
